export const BLANK_TARGET: string = "_blank"
export const SELF_TARGET: string = "_self"
